import { EN_LANGUAGE, US_REGION, DE_LANGUAGE, DE_REGION, NL_LANGUAGE, NL_REGION, FR_LANGUAGE, FR_REGION, GB_REGION } from '@lemonade-hq/lemonation';
import { PageTarget } from '../helpers/routes.esm.js';

/* eslint-disable @typescript-eslint/naming-convention */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _DEFAULT_HEADER_LINKS_US_REGION_EN_LANGUAGE, _DEFAULT_FOOTER_LINKS_US_REGION_EN_LANGUAGE;
var _obj, _obj1, _obj2, _obj3;
var DEFAULT_HEADER_LINKS = (_obj3 = {}, _define_property(_obj3, US_REGION, _define_property({}, EN_LANGUAGE, [
    "renters",
    "homeowners",
    "car",
    "pet",
    "life",
    "giveback"
])), _define_property(_obj3, DE_REGION, (_obj = {}, _define_property(_obj, EN_LANGUAGE, [
    "home",
    "faq",
    "claims",
    "giveback",
    "policy_two"
]), _define_property(_obj, DE_LANGUAGE, [
    "home",
    "faq",
    "claims",
    "giveback",
    "renters_hub",
    "policy_two"
]), _obj)), _define_property(_obj3, NL_REGION, (_obj1 = {}, _define_property(_obj1, EN_LANGUAGE, [
    "home",
    "faq",
    "claims",
    "giveback",
    "policy_two"
]), _define_property(_obj1, NL_LANGUAGE, [
    "home",
    "faq",
    "claims",
    "giveback",
    "renters_hub",
    "policy_two"
]), _obj1)), _define_property(_obj3, FR_REGION, (_obj2 = {}, _define_property(_obj2, EN_LANGUAGE, [
    "renters",
    "homeowners",
    "faq",
    "claims",
    "giveback",
    "policy_two"
]), _define_property(_obj2, FR_LANGUAGE, [
    "renters",
    "homeowners",
    "faq",
    "claims",
    "giveback",
    "policy_two"
]), _obj2)), _define_property(_obj3, GB_REGION, _define_property({}, EN_LANGUAGE, [
    "home",
    "faq",
    "claims",
    "giveback",
    "tips"
])), _obj3);
var ALTERNATIVE_LINKS = [
    "terms_of_service",
    "legal_stuff",
    "privacy_policy",
    "accessibility",
    "manage_cookies",
    "do_not_share_my_personal_information"
];
var _obj4;
var ALTERNATIVE_LINKS_BY_REGION = (_obj4 = {}, _define_property(_obj4, US_REGION, ALTERNATIVE_LINKS), _define_property(_obj4, DE_REGION, ALTERNATIVE_LINKS), _define_property(_obj4, NL_REGION, ALTERNATIVE_LINKS), _define_property(_obj4, FR_REGION, ALTERNATIVE_LINKS), _define_property(_obj4, GB_REGION, ALTERNATIVE_LINKS), _obj4);
var _obj5, _obj6, _obj7, _obj8;
var DEFAULT_FOOTER_LINKS = (_obj8 = {}, _define_property(_obj8, US_REGION, _define_property({}, EN_LANGUAGE, [
    {
        renters: [
            "renters_insurance_main_page",
            "explaining_renters",
            "what_is_renters_insurance",
            "renters_insurance_coverage",
            "renters_insurance_cost",
            "how_to_get_renters_insurance",
            "car_and_renters_bundle"
        ]
    },
    {
        car: [
            "car_insurance_main_page",
            "explaining_car",
            "pay_per_mile_car_insurance",
            "car_insurance_coverage",
            "car_insurance_cost",
            "comprehensive_car_insurance",
            "car_insurance_by_vehicle"
        ]
    },
    {
        pet: [
            "pet_insurance_main_page",
            "explaining_pet",
            "dog_insurance",
            "cat_insurance",
            "compare_pet_insurance",
            "pet_insurance_coverage",
            "pet_insurance_cost"
        ]
    },
    {
        resources: [
            "blog",
            "faq",
            "global_expansion",
            "insuropedia",
            "sitemap"
        ]
    },
    {
        homeowners: [
            "homeowners_insurance_main_page",
            "explaining_homeowners",
            "what_is_homeowners_insurance",
            "homeowners_insurance_coverage",
            "homeowners_insurance_cost",
            "how_much_home_insurance_do_i_need",
            "car_and_home_bundle"
        ]
    },
    {
        life: [
            "term_life_insurance_main_page",
            "explaining_life",
            "life_insurance_coverage",
            "no_exam_life_insurance",
            "how_does_life_insurance_work",
            "how_much_life_insurance_do_i_need",
            "contingent_beneficiary"
        ]
    },
    {
        features: [
            "claims",
            "giveback",
            "policy_two",
            "api"
        ]
    },
    {
        company: [
            "makers",
            "partners_program",
            "investors",
            "transparency",
            "reviews"
        ]
    }
])), _define_property(_obj8, DE_REGION, (_obj5 = {}, _define_property(_obj5, EN_LANGUAGE, [
    {
        privateLiabilityInsurance: [
            "blog_en_de_liability_insurance_germany",
            "blog_en_de_deductible",
            "blog_en_de_insurances_in_germany",
            "blog_en_de_laptop_insurance_germany",
            "blog_en_de_camera_insurance"
        ]
    },
    {
        features: [
            "claims",
            "giveback",
            "policy_two"
        ]
    },
    {
        resources: [
            "expats_de",
            "faq",
            "global_expansion",
            "imprint"
        ]
    }
]), _define_property(_obj5, DE_LANGUAGE, [
    {
        privateLiabilityInsurance: [
            "personal_liability_hub",
            "insurance_as_tenant",
            "insurance_policies_hub",
            "multiple_insurance_hub",
            "facts_insurance_hub"
        ]
    },
    {
        homeContentInsurance: [
            "renters_hub",
            "content_insurance_hub",
            "costs_home_contents_insurance_hub",
            "homeowners_insurance_hub",
            "external_insurance_hub"
        ]
    },
    {
        features: [
            "claims",
            "giveback",
            "policy_two"
        ]
    },
    {
        resources: [
            "global_blog_de",
            "faq",
            "global_expansion",
            "sitemap"
        ]
    }
]), _obj5)), _define_property(_obj8, NL_REGION, (_obj6 = {}, _define_property(_obj6, EN_LANGUAGE, [
    {
        products: [
            "blog_en_nl_content_insurance",
            "blog_en_nl_liability_insurance"
        ]
    },
    {
        features: [
            "claims",
            "giveback",
            "policy_two"
        ]
    },
    {
        resources: [
            "expats_nl",
            "faq",
            "global_expansion"
        ]
    },
    {
        company: [
            "makers",
            "investors",
            "global_reviews"
        ]
    }
]), _define_property(_obj6, NL_LANGUAGE, [
    {
        homeContentInsurance: [
            "renters_hub",
            "home_content_insurance_hub",
            "cost_content_insurance_hub",
            "bicycle_insurance_hub",
            "insuring_e_bike_hub",
            "phone_insurance_hub"
        ]
    },
    {
        liabilityInsurance: [
            "personal_liability_hub",
            "liability_insurance_hub",
            "third_party_liability_insurance_hub",
            "private_liability_insurance_hub"
        ]
    },
    {
        buildingInsurance: [
            "what_is_building_insurance",
            "how_much_does_home_insurance_cost",
            "differences_between_content_and_building_insurance",
            "mandatory_building_insurance",
            "woz_value",
            "apartment_building_insurance"
        ]
    },
    {
        features: [
            "claims",
            "giveback",
            "policy_two"
        ]
    },
    {
        resources: [
            "global_blog_nl",
            "faq",
            "global_expansion",
            "insuropedia_nl",
            "sitemap",
            "makers"
        ]
    }
]), _obj6)), _define_property(_obj8, FR_REGION, (_obj7 = {}, _define_property(_obj7, EN_LANGUAGE, [
    {
        products: [
            "renters",
            "homeowners"
        ]
    },
    {
        features: [
            "claims",
            "giveback",
            "policy_two"
        ]
    },
    {
        resources: [
            "global_blog_fr",
            "faq",
            "complaints",
            "global_expansion"
        ]
    },
    {
        company: [
            "makers",
            "investors",
            "global_transparency",
            "global_reviews"
        ]
    }
]), _define_property(_obj7, FR_LANGUAGE, [
    {
        renters: [
            "assurance_habitation_locataire",
            "guide_assurance_locataires",
            "assurance_responsabilit\xe9_civile",
            "assurance_habitation_pour_\xe9_tudiants",
            "prix_d_une_assurance_habitation",
            "assurance_scolaire",
            "attestation_d_assurance_habitation",
            "assurance_t\xe9l\xe9phone",
            "paiement_assurance_habitation"
        ]
    },
    {
        homeowners: [
            "assurance_habitation",
            "en_quoi_notre_assurance_est_diff\xe9rente",
            "propri\xe9taires_occupants",
            "propri\xe9taires_non_occupants",
            "locations_saisonni\xe8res"
        ]
    },
    {
        features: [
            "claims",
            "giveback",
            "policy_two"
        ]
    },
    {
        resources: [
            "global_blog_fr",
            "faq",
            "complaints",
            "global_expansion",
            "insuropedia",
            "renters_hub",
            "sitemap"
        ]
    }
]), _obj7)), _define_property(_obj8, GB_REGION, _define_property({}, EN_LANGUAGE, [
    {
        homeInsurance: [
            "home_insurance_hub",
            "home_insurance_coverage_hub",
            "home_emergency_cover",
            "flood_insurance"
        ]
    },
    {
        contentInsurance: [
            "content_insurance_hub",
            "content_insurance_cost_hub",
            "content_insurance_coverage_hub",
            "personal_liability_hub",
            "insurance_valuables_items_hub",
            "bike_insurance_hub",
            "phone_insurance_hub"
        ]
    },
    {
        buildingInsurance: [
            "building_insurance_hub",
            "building_insurance_coverage_hub",
            "building_insurance_cost_hub"
        ]
    },
    {
        features: [
            "claims",
            "giveback",
            "global_api"
        ]
    },
    {
        resources: [
            "global_blog_uk",
            "faq",
            "global_expansion",
            "sitemap"
        ]
    },
    {
        company: [
            "makers",
            "investors",
            "global_transparency",
            "global_reviews"
        ]
    }
])), _obj8);
var DEFAULT_LINK_TARGETS = {
    covid_19: PageTarget.BLANK
};
var DEFAULT_HEADER_LINKS_WITH_CRYPTO = _object_spread_props(_object_spread({}, DEFAULT_HEADER_LINKS), _define_property({}, GB_REGION, _define_property({}, EN_LANGUAGE, [
    "home",
    "faq",
    "claims",
    "giveback",
    "contents",
    "gravity"
])));
var DEFAULT_FOOTER_LINKS_WITH_CRYPTO = _object_spread_props(_object_spread({}, DEFAULT_FOOTER_LINKS), _define_property({}, GB_REGION, _define_property({}, EN_LANGUAGE, [
    {
        features: [
            "claims",
            "giveback",
            "contents",
            "gravity"
        ]
    },
    {
        resources: [
            "faq",
            "global_expansion"
        ]
    },
    {
        company: [
            "makers",
            "legal_stuff",
            "privacy_policy",
            "terms_of_service",
            "manage_cookies",
            "do_not_share_my_personal_information"
        ]
    }
])));
var DEFAULT_HEADER_LINKS_NO_CAR = _object_spread_props(_object_spread({}, DEFAULT_HEADER_LINKS), _define_property({}, US_REGION, _define_property({}, EN_LANGUAGE, (_DEFAULT_HEADER_LINKS_US_REGION_EN_LANGUAGE = DEFAULT_HEADER_LINKS[US_REGION][EN_LANGUAGE]) === null || _DEFAULT_HEADER_LINKS_US_REGION_EN_LANGUAGE === void 0 ? void 0 : _DEFAULT_HEADER_LINKS_US_REGION_EN_LANGUAGE.filter(function(link) {
    return link !== "car";
}))));
var DEFAULT_FOOTER_LINKS_NO_CAR = _object_spread_props(_object_spread({}, DEFAULT_FOOTER_LINKS), _define_property({}, US_REGION, _define_property({}, EN_LANGUAGE, (_DEFAULT_FOOTER_LINKS_US_REGION_EN_LANGUAGE = DEFAULT_FOOTER_LINKS[US_REGION][EN_LANGUAGE]) === null || _DEFAULT_FOOTER_LINKS_US_REGION_EN_LANGUAGE === void 0 ? void 0 : _DEFAULT_FOOTER_LINKS_US_REGION_EN_LANGUAGE.map(function(column) {
    var _column_features;
    return _object_spread_props(_object_spread({}, column), {
        features: (_column_features = column.features) === null || _column_features === void 0 ? void 0 : _column_features.filter(function(link) {
            return link !== "car";
        })
    });
}))));
var _obj9, _obj10, _obj11, _obj12;
var NO_LINKS = (_obj12 = {}, _define_property(_obj12, US_REGION, _define_property({}, EN_LANGUAGE, [])), _define_property(_obj12, DE_REGION, (_obj9 = {}, _define_property(_obj9, EN_LANGUAGE, []), _define_property(_obj9, DE_LANGUAGE, []), _obj9)), _define_property(_obj12, NL_REGION, (_obj10 = {}, _define_property(_obj10, EN_LANGUAGE, []), _define_property(_obj10, NL_LANGUAGE, []), _obj10)), _define_property(_obj12, FR_REGION, (_obj11 = {}, _define_property(_obj11, EN_LANGUAGE, []), _define_property(_obj11, FR_LANGUAGE, []), _obj11)), _define_property(_obj12, GB_REGION, _define_property({}, EN_LANGUAGE, [])), _obj12);
var HEADER_LINKS_TAGGED_WITH_LABEL = _define_property({}, US_REGION, _define_property({}, EN_LANGUAGE, {}));

export { ALTERNATIVE_LINKS, ALTERNATIVE_LINKS_BY_REGION, DEFAULT_FOOTER_LINKS, DEFAULT_FOOTER_LINKS_NO_CAR, DEFAULT_FOOTER_LINKS_WITH_CRYPTO, DEFAULT_HEADER_LINKS, DEFAULT_HEADER_LINKS_NO_CAR, DEFAULT_HEADER_LINKS_WITH_CRYPTO, DEFAULT_LINK_TARGETS, HEADER_LINKS_TAGGED_WITH_LABEL, NO_LINKS };
